import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost";
  /** Render as the child element (e.g. an `<a>`) instead of a `<button>`. */
  asChild?: boolean;
};

export const GradientButton = React.forwardRef<HTMLButtonElement, Props>(function GradientButton(
  { variant = "primary", className = "", asChild = false, children, ...rest },
  ref,
) {
  const Comp = asChild ? Slot : "button";
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium transition-all duration-200";
  const styles =
    variant === "primary"
      ? "btn-gradient hover:-translate-y-px hover:brightness-110"
      : "glass-pill text-white hover:bg-white/10";
  return (
    <Comp ref={ref} className={`${base} ${styles} ${className}`} {...rest}>
      {children}
    </Comp>
  );
});
